import { literal } from "zod";
import { GetRelevantProductsOutputParser } from "../../concierge-conversation/product-details-db-parser";
import { ContentType } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";

/**
 * This is the message type for the response to the tool call to get relevant
 * products.
 */
export const RelevantProductsMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.TOOL_CALL_RELEVANT_PRODUCTS),
  structuredContent: GetRelevantProductsOutputParser.optional(),
});

export const RelevantProductsMessageDbParser =
  RelevantProductsMessageSchema.merge(AutoGeneratedFieldsSchema);
